import { useState } from "react";
import axios from "axios";
import { BellRing, Check, Loader2 } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;
export const OPEN_REMIND = "sb-open-remind";
export const openRemind = () => window.dispatchEvent(new Event(OPEN_REMIND));

export const RemindForm = ({ dark = false, id = "remind" }) => {
  const [phone, setPhone] = useState("");
  const [consent, setConsent] = useState(false);
  const [state, setState] = useState("idle");
  const [already, setAlready] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!API) { setErr("Reminders aren't available right now."); return; }
    setState("busy"); setErr("");
    try {
      const { data } = await axios.post(`${API}/api/reminders`, { phone, consent });
      setAlready(!!data?.already);
      setState("done");
    } catch (ex) {
      setErr(ex?.response?.data?.detail ?? "Something went wrong. Please try again.");
      setState("idle");
    }
  };

  if (state === "done") {
    return (
      <p data-testid={`${id}-success`} className={`inline-flex items-center gap-2 rounded-2xl px-4 py-3 font-semibold ${dark ? "bg-white/10 text-white" : "bg-[#7BD88F]/25 text-[#1B1530]"}`}>
        <Check className="h-5 w-5 shrink-0 text-[#7BD88F]" /> {already ? "You're already on the list." : "You're on the list."} We'll text you at 10am AST / 9am EST on Oct 16.
      </p>
    );
  }

  const muted = dark ? "text-white/75" : "text-[#4A4560]";
  return (
    <form data-testid={`${id}-form`} onSubmit={submit} className="w-full max-w-md space-y-2.5">
      <div className="flex flex-wrap gap-2">
        <input data-testid={`${id}-phone-input`} type="tel" inputMode="tel" autoComplete="tel" required value={phone} onChange={(e) => setPhone(e.target.value)}
          placeholder="Mobile number" aria-label="Mobile number"
          className={`w-0 min-w-[170px] flex-[1_1_170px] h-12 rounded-full px-5 outline-none focus:ring-2 focus:ring-[#FFB21A] ${dark ? "bg-white text-[#1B1530]" : "bg-white border border-[#1B1530]/15"}`} />
        <button data-testid={`${id}-submit`} type="submit" disabled={state === "busy" || !consent}
          className="flex-[1_0_auto] justify-center h-12 px-5 rounded-full bg-[#FF5A5F] text-white font-bold inline-flex items-center gap-2 whitespace-nowrap hover:bg-[#FFB21A] hover:text-[#1B1530] transition-colors disabled:opacity-60">
          {state === "busy" ? <Loader2 className="h-4 w-4 animate-spin" /> : <BellRing className="h-4 w-4" />} Text me at launch
        </button>
      </div>
      <label className={`flex items-start gap-2 text-xs leading-snug ${muted}`}>
        <input data-testid={`${id}-consent`} type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} className="mt-0.5 accent-[#FF5A5F]" />
        Text me when Swole Bears drops on Oct 16. One launch text plus a confirmation. Msg &amp; data rates may apply. Reply STOP to opt out.
      </label>
      {err && <p data-testid={`${id}-error`} className="text-sm font-semibold text-[#FF8A8D]">{err}</p>}
    </form>
  );
};
